module.exports = __webpack_public_path__ + "img/default.af785fd2.jpg";